import { IS_SSR } from '@libs/common-next';
import { NAVIGATION_URLS } from '@libs/core';

export const generateVelocityCreateAccountUrl = (queryKey?: string, queryValue?: string): string => {
    if (IS_SSR) return '';

    const currentPage = new URL(window.location.href);
    if (queryKey && queryValue) {
        currentPage.searchParams.set(queryKey, queryValue);
    }
    const redirectUrl = encodeURIComponent(currentPage.pathname + currentPage.search);
    return `${NAVIGATION_URLS.velocity.createAccount}?redirectUrl=${redirectUrl}`;
};
